export default "__VITE_ASSET__BR15o5av__"